// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Material UI icons as CSS font family */

@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format('woff2');
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -moz-font-feature-settings: 'liga';
  -moz-osx-font-smoothing: grayscale;
}

/* Notification / Modal showed right after loged in - styles */

.ant-modal.afterLogInNotification{
  width: 716px !important;
}

.ant-modal.afterLogInNotification .ant-modal-content{
  background-color: #FFFFFF;
  box-shadow: 0px 24px 48px rgba(0, 0, 0, 0.08);
  border-radius: 4px
}

.ant-modal.afterLogInNotification.hide-header .ant-modal-header{
  display: none;
}

.ant-modal.afterLogInNotification .ant-modal-body{
  padding: 70px;
}

.afterLogInNotification .title{
  text-align: center;
  font-size: 28px;
  line-height: 37px;
  font-weight: 600;
  letter-spacing: 0;
  color: #212121;
  margin-bottom: 15px;
}

.afterLogInNotification .subtitle{
  text-align: center;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0;
  color: #888888;
  margin-bottom: 45px;
}

.afterLogInNotification .steps-holder{

}

.afterLogInNotification .steps-holder .step-box{
  text-align: left;
  padding: 10px;
}

.afterLogInNotification .steps-holder .step-box .link{
  display: block;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ededed;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  /*height: 180px;*/
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.afterLogInNotification .steps-holder .step-box .link:hover:not(.is-div){
  border: 1px solid #dcdcdc;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.afterLogInNotification .steps-holder .step-box .link.icon::after {
  position: absolute;
  top: 23px;
  right: 23px;
  /* display: inline-block; */
  display: none;
  font-family: 'Material Icons';
  font-size: 28px;
}

.afterLogInNotification .steps-holder .step-box .link.icon.warning::after {
  content: 'error';
  color: #FFCF3F;
}
.afterLogInNotification .steps-holder .step-box .link.icon.error::after {
  content: 'cancel';
  color: #F86567;
}
.afterLogInNotification .steps-holder .step-box .link.icon.success::after {
  content: 'check_circle';
  color: #66CC80;
}

.afterLogInNotification .steps-holder .step-box .step-title{
  text-align: left;
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
  letter-spacing: 0;
  color: #212121;
  margin-bottom: 10px;
}

.afterLogInNotification .steps-holder .step-box .step-sub-title {
  font-weight: 500;
  color: #222;
  margin-bottom: 5px;
}

.afterLogInNotification .steps-holder .step-box .step-descr{
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0;
  color: #444;
  margin-bottom: 20px;
}

.afterLogInNotification .steps-holder .step-box .step-descr a {
  text-decoration: underline;
  color: inherit;
}

.afterLogInNotification .steps-holder .step-box.step-3 .first-line{
  margin-bottom: 10px;
  text-decoration: underline;
}

.afterLogInNotification .steps-holder .step-box.step-3 .note{
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/AfterLogInNotification.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0GAA0G;AAC5G;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,8DAA8D;;AAE9D;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;AAEA;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,2CAA2C;EAC3C,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Material UI icons as CSS font family */\n\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format('woff2');\n}\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -moz-font-feature-settings: 'liga';\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Notification / Modal showed right after loged in - styles */\n\n.ant-modal.afterLogInNotification{\n  width: 716px !important;\n}\n\n.ant-modal.afterLogInNotification .ant-modal-content{\n  background-color: #FFFFFF;\n  box-shadow: 0px 24px 48px rgba(0, 0, 0, 0.08);\n  border-radius: 4px\n}\n\n.ant-modal.afterLogInNotification.hide-header .ant-modal-header{\n  display: none;\n}\n\n.ant-modal.afterLogInNotification .ant-modal-body{\n  padding: 70px;\n}\n\n.afterLogInNotification .title{\n  text-align: center;\n  font-size: 28px;\n  line-height: 37px;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #212121;\n  margin-bottom: 15px;\n}\n\n.afterLogInNotification .subtitle{\n  text-align: center;\n  font-size: 16px;\n  line-height: 21px;\n  letter-spacing: 0;\n  color: #888888;\n  margin-bottom: 45px;\n}\n\n.afterLogInNotification .steps-holder{\n\n}\n\n.afterLogInNotification .steps-holder .step-box{\n  text-align: left;\n  padding: 10px;\n}\n\n.afterLogInNotification .steps-holder .step-box .link{\n  display: block;\n  padding: 20px;\n  border-radius: 4px;\n  border: 1px solid #ededed;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);\n  /*height: 180px;*/\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n.afterLogInNotification .steps-holder .step-box .link:hover:not(.is-div){\n  border: 1px solid #dcdcdc;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n.afterLogInNotification .steps-holder .step-box .link.icon::after {\n  position: absolute;\n  top: 23px;\n  right: 23px;\n  /* display: inline-block; */\n  display: none;\n  font-family: 'Material Icons';\n  font-size: 28px;\n}\n\n.afterLogInNotification .steps-holder .step-box .link.icon.warning::after {\n  content: 'error';\n  color: #FFCF3F;\n}\n.afterLogInNotification .steps-holder .step-box .link.icon.error::after {\n  content: 'cancel';\n  color: #F86567;\n}\n.afterLogInNotification .steps-holder .step-box .link.icon.success::after {\n  content: 'check_circle';\n  color: #66CC80;\n}\n\n.afterLogInNotification .steps-holder .step-box .step-title{\n  text-align: left;\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #212121;\n  margin-bottom: 10px;\n}\n\n.afterLogInNotification .steps-holder .step-box .step-sub-title {\n  font-weight: 500;\n  color: #222;\n  margin-bottom: 5px;\n}\n\n.afterLogInNotification .steps-holder .step-box .step-descr{\n  text-align: left;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0;\n  color: #444;\n  margin-bottom: 20px;\n}\n\n.afterLogInNotification .steps-holder .step-box .step-descr a {\n  text-decoration: underline;\n  color: inherit;\n}\n\n.afterLogInNotification .steps-holder .step-box.step-3 .first-line{\n  margin-bottom: 10px;\n  text-decoration: underline;\n}\n\n.afterLogInNotification .steps-holder .step-box.step-3 .note{\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
